const HAS_WINDOW = typeof window !== 'undefined';

export { HAS_WINDOW };
//# sourceMappingURL=window.js.map
